export const LISTING_TGB_TRACKING_LABELS = {
  map: {
    show: 'Listing_show_TGB',
    click: 'Listing_click_TGB',
  },
  serp: {
    show: 'Listing_show_TGB',
    click: 'Listing_click_TGB',
  },
};

export const LISTING_TGB_SLIDER_TRACKING_LABELS = {
  map: null,
  serp: {
    show: 'Listing_show_slider_TGB',
    click: 'Listing_click_slider_TGB',
  },
};
